export default __webpack_public_path__ + "static/media/Team1.163533ce.jpg";